import { render, staticRenderFns } from "./CxMessageToast.vue?vue&type=template&id=d08de4b6&scoped=true"
import script from "./CxMessageToast.vue?vue&type=script&lang=js"
export * from "./CxMessageToast.vue?vue&type=script&lang=js"
import style0 from "./CxMessageToast.vue?vue&type=style&index=0&id=d08de4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08de4b6",
  null
  
)

export default component.exports